<template>
  <NuxtErrorBoundary v-bind="$attrs">
    <slot />

    <template #error="{ error, clearError }">
      <slot :clear-error :error name="error" />
    </template>
  </NuxtErrorBoundary>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>
